module.exports = __webpack_public_path__ + "img/swiper2.e2cb2518.jpg";